<template>
  <v-item-group>
    <v-container grid-list-md pa-1 >
      <!-- <span style="font-size: .9em; opacity: .7">{{label}}</span> -->
      <v-text-field
          class = "time"
          :label="label"
          v-model="timeInput"
          v-facade="{mask: 'Hh:Mm', tokens: timeToken}"
          @focus="e => $store.dispatch('inputFocus', e)"
          :disabled="disabled"
          :loading="loading"
          hide-details
          dense
          outlined
          filled
        >
          <template slot="append-outer">
            <v-menu
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{on,attrs}">
                <v-badge style="width: 100%;"
                  dot
                  left
                  color="warning"
                  :value="changed"
                >
                  <v-btn
                    style="height: 40px;"
                    text
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                  >
                  <v-icon>mdi-clock</v-icon>
                  </v-btn>
                </v-badge>
              </template>
              <v-card>
                <v-card-title class="py-3 px-4" style="background: var(--v-primary-base); color:#fff">{{label}}</v-card-title>
                <v-layout>
                  <TimeInput 
                    v-model = "hours"
                    :count = "23"
                    :limit="false"
                    :label = "$t('Час')"
                    />
                    <TimeInput
                    v-model = "minutes"
                    :limit="false"
                    :count = "59"
                    :label = "$t('Мин')"
                  />
                </v-layout>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn  text color="primary" @click.stop="getNow()">Сейчас</v-btn>
                  <v-btn  text color="error" @click.stop="clearTime()">Очистить</v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
          </template>
        </v-text-field>
    </v-container>
  </v-item-group>
</template>

<script>
import TimeInput from './TimeInput'

export default {
  props: {
    value: {
      type: String,
      default: '00:00'
    },
    label: String,
    disabled: Boolean,
    loading: Boolean,
    original_value: String,
    min: {
      type: String,
      default: '00:00'
    },
    max:{
      type: String,
      default: '23:59'
    }
  },
  data:()=>{
    return{
      masked: false,
      timeToken: {
        'H': {pattern: /[0-2]/},
        'h': {pattern: /[0-9]/},
        'M': {pattern: /[0-5]/},
        'm': {pattern: /[0-9]/}
      },
      temp: '',
      min_minutes: 0,
      max_minutes: 59
    }
  },
  computed: {
    changed(){
      return this.original_value ? this.original_value != this.value : false
    },
    time_split(){
      return this.value.split(':')
    },
    hours:{
      set(v){
        this.$emit('input', `${v}:${this.minutes}`)
      },
      get(){
        return Number(this.time_split[0])
      }
    },

    minutes:{
      set(v){
        this.$emit('input', `${this.hours}:${v}`)
      },
      get(){
        return Number(this.time_split[1])
      }
    },

    timeInput: {
      set(v){
        if(v.charAt(0) == '2'){
          if(v.charAt(1).match(/[4-9]/) != null){
            let temp = v
            v = temp.replace(v[1], '3')
          }
        }
        if(v.match(/^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/)!=null){
          this.$emit('input', v)
        }
      },
      get(){
        let hours = `${(''+this.time_split[0].length) < 2 ? `0${this.time_split[0]}`: this.time_split[0]}`
        let minutes = `${(''+this.time_split[1].length) < 2 ? `0${this.time_split[1]}`: this.time_split[1]}`
        return `${hours}:${minutes}` 
      }
    },
  },
  methods:{
    getNow(){
      let now = new Date()
      let minutes = (''+ now.getMinutes()).length < 2 ? `0${now.getMinutes()}` : `${now.getMinutes()}`
      let hours = (''+ now.getHours()).length < 2 ? `0${now.getHours()}` : `${now.getHours()}`
      this.$emit('input', `${hours}:${minutes}`)
    },
    clearTime(){
      this.$emit('input', '00:00')  
    },
  },
  mounted(){
    if(this.limit){
      this.$emit('input', this.min)
    }
  },
  watch:{
  },
  components:{
    TimeInput
  }
}
</script>

<style>
  .time .v-input__append-outer{
    margin: 0 !important;
}
</style>